
import HeartIcon from '../icons/HeartIcon.vue';

export default {
  name: 'AnimatedLikeButton',
  components: { HeartIcon },

  props: {
    isLiked: {
      type: Boolean,
      default: false,
    },
    likeCount: {
      type: Number,
      default: -1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    fontSize: {
      type: String,
      default: '2',
    },
    fontWeight: {
      type: String,
      default: '3',
    },
  },
  data() {
    return {
      previousLikeCount: null,
      direction: 'up',
      animationInProgress: false,
    };
  },
  computed: {
    colorClass() {
      return this.isLiked ? 'text-primary' : 'text-neutral-10';
    },
  },
  watch: {
    likeCount(newVal, oldVal) {
      if (oldVal === -1) return;

      this.previousLikeCount = oldVal;
      this.direction = newVal > oldVal ? 'up' : 'down';

      // Using 10ms timeout to allow Vue to complete the DOM update cycle
      // before clearing previousLikeCount. This ensures the animation has
      // time to start properly. Without this, the old value would be removed
      // immediately, preventing the counter animation from being visible in some cases.
      setTimeout(() => {
        this.previousLikeCount = null;
      }, 10);
    },
  },
  mounted() {
    // Disabling animation on component load
    setTimeout(() => {
      const container = this.$el;
      if (container) {
        container.classList.remove('preload-container');
      }
    }, 500);
  },
  methods: {
    emitToggle() {
      // Stop any emits until the animation is done
      if (this.animationInProgress) return;

      this.animationInProgress = true;
      this.$emit('onLike');

      // Reset the flag on animation end, the timeout should be adjusted based on the animation length
      setTimeout(() => {
        this.animationInProgress = false;
      }, 600);
    },
  },
};
